







































import { Component, Prop, Vue } from "vue-property-decorator";
import { card } from "../board";
import { Action, Mutation } from "vuex-class";
import moment from "moment";

@Component
export default class Card extends Vue {
  @Action private deleteCard;
  @Action private updateCard;
  @Prop() card!: card;
  @Mutation setCommentsModalIsActive;
  @Mutation setModalIsActive;
  @Mutation setSelectedCard;
  @Mutation("removeCard") removeCardById;
  private isCardHovered = false;
  private cardEdit = false;

  get cardDescription() {
    return this.card._id + "-desc";
  }

  public toggleCardHover() {
    this.isCardHovered = !this.isCardHovered;
  }

  public toggleCardEdit() {
    this.cardEdit = !this.cardEdit;
    if (this.cardEdit) {
      this.$nextTick(() => {
        const cardDescElem = document.getElementById(this.cardDescription);
        if (cardDescElem) {
          cardDescElem.focus();
        }
      });
    }
  }

  public saveCard() {
    this.updateCard(this.card);
    this.toggleCardEdit();
  }

  public dragStart(e) {
    e.dataTransfer.dropEffect = "move";
    console.log(this.card);
    e.dataTransfer.setData("card_id", this.card._id);
    e.dataTransfer.setData("dragged_card", JSON.stringify(this.card));
  }

  get cardDate() {
    if (this.card.createdOn) {
      const formattedDate = moment(this.card.createdOn.toString()).format(
        "MMM DD, YYYY"
      );
      return formattedDate;
    }
    return "";
  }

  removeCard() {
    this.deleteCard(this.card);
    this.removeCardById(this.card._id);
  }

  public showDetail() {
    this.setSelectedCard(this.card);
    this.setModalIsActive(true);
  }

  public showComments() {
    this.setSelectedCard(this.card);
    this.setCommentsModalIsActive(true);
  }
}
